
import $ from "jquery";
import Swal from 'sweetalert2';
const pagination = require('pagination');
const bodyblog = document.querySelector(".bodyblog");
const paginationblog = document.querySelector(".paginationblog");
const paginationblogul = document.querySelector(".paginationblog-ul");
const elementpage = document.querySelectorAll(".paginationblog-ul .paginationblog-ul-item")
const inputsearch = document.querySelector(".queryblog");
const itemscat = document.querySelectorAll(".navcategoriesblog__li");
const loadingblog = document.querySelector(".loadingblog");
const tobodyblog = document.querySelector(".tobodyblog");
const inforesultssearch = document.querySelector(".inforesults-search");
const carruselblog = document.querySelector(".BlogsliderTop.bg-lightgray");
var activecategory =null;
var titlecategory = '';
var timeout = null;

window.copyblog = (urlblog) =>{
  copyToClipboard(urlblog)
  .then(() => {
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: 'Se ha copiado la url para que la pueda compartir',
      showConfirmButton: false,
      timer: 1500
    })
  })
  .catch(() => Swal.fire({
    position: 'top-end',
    icon: 'error',
    title: 'No se pudo copiar la url',
    showConfirmButton: false,
    timer: 1500
  })
  );
}

itemscat.forEach(cat=>{
  cat.addEventListener("click",ev=>{
    inforesultssearch.classList.add('d-none');
    inputsearch.value="";
    activecategory =null;
    titlecategory= "";
    let { target } = ev;
    if(carruselblog.classList.contains('d-none')){
      togglecarousel(false)
    }
    //revisar si hay una categoria activa
    if(target.classList.contains('active')){
      target.classList.remove("active");
      loadingblog.classList.remove("hide");
      loadingblog.classList.add("show");
      searchblogs(1, '',null);
      tobodyblog.click();
    }else{
      target.classList.add("active");
      $(target).siblings().removeClass("active");
      activecategory=target.dataset.id;
      titlecategory= target.dataset.title;
      loadingblog.classList.remove("hide");
      loadingblog.classList.add("show");
      searchblogs(1, '',target.dataset.id);
      tobodyblog.click();
    }
  })
});

window.doDelayedSearch =()=> {
  if (timeout) {  
    clearTimeout(timeout);
  }
  timeout = setTimeout(function() {
    clearcategories();
    loadingblog.classList.remove("hide");
    loadingblog.classList.add("show");
    let searchinput = inputsearch.value !== ''? inputsearch.value: '';
    searchblogs(1, searchinput,null);
  }, 2000);
}

window.refreshcat = function (cat, title) {
  activecategory=cat;
  titlecategory= title;
  loadingblog.classList.remove("hide");
  loadingblog.classList.add("show");
   searchblogs(1, '',cat);
}

window.initblog = function () {
  loadingblog.classList.remove("hide");
  loadingblog.classList.add("show");
  searchblogs(1, 'init',null);
}

window.refreshpage = function (page) {
  let searchinput = inputsearch.value !== ''? inputsearch.value: '';
  loadingblog.classList.remove("hide");
  loadingblog.classList.add("show");
  tobodyblog.click();
  if(activecategory != null){
    searchblogs(page, searchinput,activecategory);
  }else{
    searchblogs(page, searchinput,null);
  }
}

function togglecarousel(ban) {
  if(ban){
    carruselblog.style.opacity = 0;
    carruselblog.classList.add("d-none");
  }else{
    carruselblog.style.opacity = 0;
    carruselblog.classList.remove("d-none");
    carruselblog.animate({ opacity: [0, 1] }, { duration: 5000, iterations: 1, easing: "ease-in" }).onfinish = (e) => {
          e.target.effect.target.style.opacity = 1;
    };
  }
}

function clearcategories() {
  activecategory=null;
  titlecategory= "";
  $('.navcategoriesblog__ul').children().removeClass('active');
}
/* search blog */

function searchblogs(page,search,cat) {
  if(cat !== null ){
    getblogscategory(page,cat).then((data) => {
      if(data.data.length === 0){
        noresults();
        return;
      }
      if(data.data.length > 0 && data.data != undefined){
          setcards(data.data);
          if (data.meta != undefined ) {
            let meta = data.meta.pagination;
            let paginator = new pagination.SearchPaginator({prelink:'/', current: Number(meta.current_page), rowsPerPage: Number(meta.per_page), totalResult: Number(meta.total)});
            let info = paginator.getPaginationData(); 
            setpagination(info.range,info.previous,info.next,meta.current_page);
          }
      }
    }).catch(err=>{
      console.log("error",err);
      noresults();
      return;
    });
  }else{
    getblogs(page,search === 'init'?'':search).then((data) => {
      if(data.data.length === 0){
        inforesultssearch.innerText=`Resultados de la busqueda : ${search}`;
        inforesultssearch.classList.remove('d-none');
        noresults();
        return;
      }
      if(data.data.length > 0 && data.data != undefined){
          if(search != '' && search != 'init' ){
            inforesultssearch.innerText=`Resultados de la busqueda : ${search}`;
            inforesultssearch.classList.remove('d-none');
            togglecarousel(true);
          }else{
            inforesultssearch.classList.add('d-none');
            if (search ==='' && search != "init" ) {
              if(carruselblog.classList.contains('d-none')){
                togglecarousel(false)
              }
            }

          }
          setcards(data.data);
          if (data.meta != undefined ) {
            let meta = data.meta.pagination;
            let paginator = new pagination.SearchPaginator({prelink:'/', current: Number(meta.current_page), rowsPerPage: Number(meta.per_page), totalResult: Number(meta.total)});
            let info = paginator.getPaginationData(); 
            setpagination(info.range,info.previous,info.next,meta.current_page);
            if(search != 'init'){
              tobodyblog.click();
            }
          }
      }
    }).catch(err=>{
      console.log("error",err);
      noresults();
      return;
    });
  }
}

/* build cards y pagination  */

function noresults() {
  bodyblog.innerHTML = "";
  paginationblogul.innerHTML="";
  loadingblog.classList.remove("show");
  loadingblog.classList.add("hide");
  $('.bodyblog').append('<p class="py-3 font-medium text-darkgray h4 w-100 text-center">No se encontraron resultados</p>');
  tobodyblog.click();
}

function setcards(data) {
  bodyblog.innerHTML = "";
  data.forEach(element => {
      $('.bodyblog').append(`<div class="col-12 col-md-6 my-3 bodyBlog__cardBlog">
      <div class="blog-slider__slide">
        <a href="${element.url}">
          <div class="blog-slider__slide-img position-relative mb-4">
              <img src="${element.imagen}" alt="{{title}}" class="position-absolute w-100 h-100">
            <div class="blog-slider__slide-excerpt position-absolute d-flex align-items-center p-3">
              <p class="text-white position-relative">
                ${element.descripcionBreve}
              </p>
            </div>
            <img alt="Contyquim" src="/img/border-logo.svg" class="border-logo">
          </div>
          <a href="${element.urlcat}" class="h6 font-medium text-white text-uppercase pl-3 pr-4 py-1 d-inline bodyBlog__cardBlog--link"> ${element.cat}</a>
          <h3 class="h6 font-medium text-darkgray pt-2">${element.title}</h3>
          <span class="d-block h6 font-medium text-darkgray bodyBlog__cardBlog--date">${element.date}</span>
        </a>
      </div>
    </div>`);
  });
  loadingblog.classList.remove("show");
  loadingblog.classList.add("hide");
}

function setpagination(range, prev, next, current) {
  paginationblogul.innerHTML="";
  //prev 
  if(prev != null){
    $(".paginationblog-ul").append(`<button onclick="window.refreshpage(${prev})" data-page="${prev}" class="paginationblog-ul-item"><svg class="svg-inline--fa fa-chevron-left fa-w-8" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" data-fa-i2svg=""><path fill="currentColor" d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"></path></svg></button>`);
  }
  range.forEach((el)=> {
    $(".paginationblog-ul").append(`<button onclick="window.refreshpage(${el})"  data-page="${el}" class="paginationblog-ul-item ${el===current? 'active' :'inactive'}">${el}</button>`)
  });
  // next 
  if(next != null){
    $(".paginationblog-ul").append(`<button onclick="window.refreshpage(${next})" data-page="${next}" class="paginationblog-ul-item"><svg class="svg-inline--fa fa-chevron-right fa-w-8" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" data-fa-i2svg=""><path fill="currentColor" d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg></button>`)
  }
}

/* fetch blogs  */

async function getblogs(page, query) {
  var data = {
      //'CSRF': $('input[name="CRAFT_CSRF_TOKEN"]').val(),
      'page':page,
      'q':query
  };
  try {
     const response = await $.ajax({
      'type': 'get',
      'contentType': 'application/x-www-form-urlencoded; charset=UTF-8',
      'cache': false,
      'data': data,
      'url': "/api/searchblog",
      'dataType': 'json',
      'timeout': 50000
     });
    return response;
  } catch (error) {
      console.error(error)
  }
}

async function getblogscategory(page, id_cat) {
var data = {
    //'CSRF': $('input[name="CRAFT_CSRF_TOKEN"]').val(),
    'cat':id_cat,
    'page':page,
};
try {
   const response = await $.ajax({
    'type': 'get',
    'contentType': 'application/x-www-form-urlencoded; charset=UTF-8',
    'cache': false,
    'data': data,
    'url': "/api/searchblog-category",
    'dataType': 'json',
    'timeout': 50000
   });
  return response;
} catch (error) {
    console.error(error)
}
}




function copyToClipboard(textToCopy) {
  // navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy);
  } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
          // here the magic happens
          document.execCommand('copy') ? res() : rej();
          textArea.remove();
      });
  }
}